 class templateCollectionJS {
    constructor() {
    //     let links = document.querySelectorAll('[data-show-more-details] a.show-details')
    //     if (links != null) {
    //         links.forEach(link => link.addEventListener('click', this.readMoreFunction.bind(this)));
    //     }
    // }

    // readMoreFunction(e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     let contentBlock = document.querySelector('.coll-descr');
    //     const isOpen = contentBlock.classList.contains('show-more');
    //     let contentBlockHeight = Utility._getHeightofHiddenEle(contentBlock)
        
    //     if (!isOpen) {
            
    //         contentBlock.style.height = contentBlockHeight + 'px';
    //         setTimeout(() => {
    //             contentBlock.style.height = '';
    //         }, 300);
    //         contentBlock.classList.add('show-more');
    //         document.querySelector('[data-read-less')?.classList.remove('d-none');
    //         document.querySelector('[data-read-more')?.classList.add('d-none');
    //     } else {
    //         contentBlock.style.height = contentBlockHeight + 'px';
    //         setTimeout(function () {
    //             contentBlock.style.height = '46' + 'px';
    //         }, 1);
    //         setTimeout(function () {
    //             contentBlock.classList.remove('show-more');
    //             document.querySelector('[data-read-less')?.classList.add('d-none');
    //             document.querySelector('[data-read-more')?.classList.remove('d-none');
    //         }, 300);

    //     }
    }

}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();

 